<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            id="aulaSelecionada.voltar"
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'aulas',
                  params: { gestaoDeAulaId: $route.params.gestaoDeAulaId },
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
            <span class="sr-only">Voltar</span>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Aula
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="gestaoDeAula">
        <v-card color="green" class="mb-5 d-flex" outlined>
          <v-card-text>
            <h4>Turma: {{ gestaoDeAula.turma.descricao }}</h4>
            <template v-if="!gestaoDeAula.is_polivalencia"> </template>
            <template v-else>
              <h4>Disciplinas:</h4>
              <div class="container">
                <div class="row">
                  <div v-for="(item, index) in gestaoDeAula.disciplinas" :key="index">
                    <v-chip class="ml-2" x-small>{{ item.descricao }} </v-chip>
                  </div>
                </div>
              </div>
            </template>
            <h4>
              Professor:
              {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[NÃO INFORMADO]" }}
            </h4>
            <h4>
              Turno:
              {{
                gestaoDeAula.turma.turno ? gestaoDeAula.turma.turno.descricao : "[NÃO INFORMADO]"
              }}
            </h4>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <ValidationObserver v-if="etapas" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitForm)" :disabled="submittingForm">
        <v-row>
          <v-col class="pt-0 pb-0" cols="6" v-if="etapas?.length">
            <ValidationProvider name="Etapa" rules="required" v-slot="{ errors }">
              <div class="mb-4">
                <e-label>
                  Etapas
                  <v-chip
                    small
                    v-if="etapaSelecionada?.periodo_extensao"
                    class="text-none"
                    :color="getChipColor(etapaSelecionada?.periodo_extensao)"
                  >
                    Extendido até: {{ dateFormatConvert(etapaSelecionada?.periodo_extensao) }}
                  </v-chip>
                </e-label>
              </div>

              <e-autocomplete
                id="aulaSelecionada.etapa"
                v-if="editing"
                :items="etapas"
                :return-object="false"
                :error-messages="errors"
                :item-text="
                  (item) =>
                    `${item.descricao} - Início: ${dateFormatConvert(
                      item.periodo_inicial
                    )} Fim: ${dateFormatConvert(item.periodo_final)}`
                "
                :item-value="(item) => item"
                v-model="etapaSelecionada"
                @change="() => verificarEtapaSelecionada()"
                label="Selecione um Etapa"
                dense
                solo
              />

              <e-autocomplete
                id="aulaSelecionada.etapa"
                v-else
                :items="etapas"
                :return-object="false"
                :error-messages="errors"
                :item-text="
                  (item) =>
                    `${item.descricao} - Início: ${dateFormatConvert(
                      item.periodo_inicial
                    )} Fim: ${dateFormatConvert(item.periodo_final)}`
                "
                :item-value="(item) => item"
                v-model="etapaSelecionada"
                @change="() => verificarEtapaSelecionada()"
                label="Selecione um Etapa"
                dense
                solo
              />
            </ValidationProvider>
          </v-col>
          <v-col>
            <v-btn
              v-if="etapaBloqueada == true && etapaPendente == false"
              style="box-shadow: none"
              color="success"
              class="text-none mt-8"
              @click="() => criarPedido(etapaSelecionada.id)"
              >Solicitar Autorização</v-btn
            >
          </v-col>
        </v-row>
        <div v-if="etapaSelecionada && etapaBloqueada == false && etapaPendente == false">
          <v-row>
            <v-col class="pt-0 pb-0" cols="6">
              <ValidationProvider name="Tipo de Aula" rules="required" v-slot="{ errors }">
                <e-label>Tipo de Aula</e-label>
                <e-autocomplete
                  id="aulaSelecionada.tipo_de_aula"
                  :items="$constants.tiposDeAulas"
                  :return-object="false"
                  :error-messages="errors"
                  v-model="aulaSelecionada.tipo_de_aula"
                  @change="() => verificaTipoDaAula()"
                  label="Selecione um tipo de aula"
                  dense
                  solo
                />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row v-if="mostrarCampos">
            <v-col class="pt-0 pb-0" cols="6">
              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="data"
                persistent
                width="450px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <ValidationProvider name="Data" rules="required" v-slot="{ errors }">
                    <e-label>Selecione uma data</e-label>
                    <v-text-field
                      id="aulaSelecionada.data"
                      v-model="aulaSelecionada.data"
                      persistent-hint
                      :disabled="!aulaSelecionada.tipo_de_aula"
                      label="Escolha uma data"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      solo
                      :error-messages="errors"
                      required
                    ></v-text-field>
                  </ValidationProvider>
                </template>

                <v-card>
                  <v-container class="calendar-container-vertical">
                    <v-row>
                      <v-col cols="12">
                        <v-card class="pa-3 calendar-card-expanded" elevation="2" outlined>
                          <v-date-picker
                            ref="datePicker"
                            v-model="data"
                            full-width
                            scrollable
                            :min="inicioPeriodoEtapa"
                            :max="fimPeriodoEtapa"
                            :allowed-dates="allowedDates"
                            :events="[
                              ...feriados.map((f) => f.data),
                              ...diasLetivos.map((l) => l.data),
                              ...diasNaoLetivos.map((d) => d.data),
                            ]"
                            :event-color="getEventColor"
                            @update:picker-date="atualizarMesVisivel"
                            color="primary"
                            header-color="primary"
                            class="expanded-date-picker"
                          >
                            <template v-slot:day="{ date, day }">
                              <v-badge
                                :color="getBadgeColor(date)"
                                :content="getBadgeContent(date)"
                                overlap
                                dot
                              >
                                <span :class="{ 'font-weight-bold': isToday(date) }">{{
                                  day
                                }}</span>
                              </v-badge>
                            </template>
                          </v-date-picker>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" class="pa-2">
                        <v-card class="events-card-below" elevation="2" outlined>
                          <v-card-title class="primary white--text pa-3">
                            <v-icon left color="white">mdi-calendar-month</v-icon>
                            Eventos do Mês
                          </v-card-title>
                          <v-divider></v-divider>

                          <v-list dense class="py-0 event-list-expanded">
                            <template v-for="(evento, index) in eventosFiltradosPorMes">
                              <v-divider v-if="index > 0" :key="`divider-${index}`"></v-divider>
                              <v-list-item class="px-3" :key="`evento-${index}`">
                                <v-list-item-icon class="mr-2">
                                  <v-icon :color="evento.cor">mdi-circle-small</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title class="d-flex align-center flex-wrap">
                                    <span class="date-label mr-2">{{
                                      formatarDia(evento.data)
                                    }}</span>
                                    <span class="event-description">
                                      {{ evento.descricao }}
                                      <v-chip
                                        v-if="evento.is_sabado_letivo"
                                        x-small
                                        color="green"
                                        class="ml-2 white--text"
                                        dark
                                      >
                                        Dia Letivo
                                      </v-chip>
                                      <v-chip
                                        v-else
                                        x-small
                                        color="red"
                                        class="ml-2 white--text"
                                        dark
                                      >
                                        Dia não letivo
                                      </v-chip>
                                    </span>
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </template>

                            <v-list-item v-if="eventosFiltradosPorMes.length === 0">
                              <v-list-item-content>
                                <v-list-item-title class="text-caption grey--text">
                                  Nenhum evento neste mês
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>

                  <v-divider></v-divider>

                  <v-card-actions class="dialog-actions">
                    <v-btn
                      id="aulaSelecionada.data-cancelar"
                      text
                      color="primary"
                      @click="modal = false"
                    >
                      Cancelar
                    </v-btn>
                    <v-btn
                      id="aulaSelecionada.data-ok"
                      text
                      color="primary"
                      @click="$refs.dialog.save(data)"
                    >
                      OK
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>

            <v-col cols="12">
              <v-col cols="12" v-if="editing">
                <div v-if="aulaSelecionada.disciplinas?.length">
                  <div class="row mb-2">
                    <e-label>Disciplinas dessa Aula</e-label>
                  </div>
                  <div class="container">
                    <div class="row">
                      <div v-for="(item, index) in aulaSelecionada.disciplinas" :key="index">
                        <v-chip x-small>{{ getNomeDisciplina(item) }} </v-chip>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
              <template v-if="!gestaoDeAula.is_polivalencia">
                <e-label>Conteúdo</e-label>
                <v-textarea
                  solo
                  dense
                  v-model="aulaSelecionada.conteudo"
                  :error-messages="errors"
                />
                <ValidationProvider
                  name="Metodologia"
                  rules="required|no_special_chars"
                  v-slot="{ errors }"
                >
                  <e-label>Metodologia</e-label>
                  <v-textarea
                    id="aulaSelecionada.metodologia"
                    solo
                    dense
                    v-model="aulaSelecionada.metodologia"
                    :error-messages="errors"
                    :maxlength="4000"
                    :counter="true"
                  >
                    <template v-slot:counter>
                      {{ (aulaSelecionada.metodologia || "").length }}/4000
                    </template>
                  </v-textarea>
                </ValidationProvider>
              </template>

              <!-- CRIAÇÃO polivalente (#7530): o usuário escolhe primeiro os horários do dia
                   (não a disciplina) — quando há mais de um horário, cada um vira uma aba
                   independente, com sua própria seleção de componentes curriculares (no
                   máximo 1 não complementar + quantos complementares forem necessários). Ao
                   enviar, cria-se 1 Aula por horário selecionado. -->
              <template v-else-if="!editing">
                <div v-if="!aulaSelecionada.data" class="text-center grey--text pa-4">
                  Selecione uma data para ver os horários disponíveis.
                </div>
                <div v-else-if="!horariosDoDiaAtual.length" class="text-center grey--text pa-4">
                  Não há horários com componentes curriculares vinculados nesse dia da semana.
                </div>
                <template v-else>
                  <ValidationProvider name="Horários" rules="required" v-slot="{ errors }">
                    <e-label class="mt-2">Horários</e-label>
                    <e-autocomplete
                      id="aulaSelecionada.horarios"
                      :items="horariosDoDiaAtual"
                      multiple
                      return-object
                      :item-text="(item) => item.descricao"
                      v-model="horariosSelecionados"
                      label="Selecione um ou mais horários"
                      dense
                      :error-messages="errors"
                    />
                  </ValidationProvider>

                  <div v-if="horariosSelecionados.length > 1" class="mb-2">
                    <div class="d-flex align-center">
                      <e-label class="mb-0">Replicar Conteúdo</e-label>
                      <e-help-tooltip
                        class="ml-2"
                        text="Usa a mesma seleção de componentes e conteúdo para todos os horários marcados. Desligue para configurar cada horário de forma independente."
                      />
                      <v-switch
                        v-model="replicarConteudo"
                        :disabled="semComponenteCurricularComum"
                        hide-details
                        class="mt-0 ml-4"
                      />
                    </div>
                    <v-alert
                      v-if="semComponenteCurricularComum"
                      dense
                      text
                      type="info"
                      class="mt-2 mb-0"
                    >
                      {{ mensagemSemComponenteComum }}
                    </v-alert>
                  </div>

                  <v-card v-if="usarSelecaoCompartilhada" outlined class="pa-3 mb-4">
                    <strong>Componentes curriculares</strong>
                    <div
                      v-if="componentesCompartilhadosDisponiveis.some((c) => !c.extra_curricular)"
                      class="text-caption grey--text mt-1 mb-2"
                    >
                      Não é possível selecionar mais de um componente curricular não complementar
                      por horário.
                    </div>
                    <div
                      v-if="!componentesCompartilhadosDisponiveis.length"
                      class="text-caption grey--text mt-2"
                    >
                      Nenhum componente curricular é comum a todos os horários selecionados.
                    </div>
                    <div
                      v-for="componente in componentesCompartilhadosDisponiveis"
                      :key="componente.id"
                    >
                      <v-checkbox
                        :input-value="componentesCompartilhados.includes(componente.id)"
                        :disabled="
                          !componente.extra_curricular &&
                          temNaoComplementarExcetoId(
                            componentesCompartilhados,
                            componentesCompartilhadosDisponiveis,
                            componente.id
                          )
                        "
                        :label="componente.descricao"
                        hide-details
                        @change="(v) => alternarComponenteCompartilhado(componente.id, v)"
                      />
                    </div>

                    <template
                      v-for="componente in componentesSelecionadosObjs(
                        componentesCompartilhadosDisponiveis,
                        componentesCompartilhados
                      )"
                    >
                      <ValidationProvider
                        :key="componente.id"
                        :vid="`conteudo-compartilhado-${componente.id}`"
                        :name="`Conteúdo de ${componente.descricao}`"
                        rules="required|no_special_chars"
                        v-slot="{ errors }"
                      >
                        <e-label class="mt-2">Conteúdo de {{ componente.descricao }}</e-label>
                        <v-textarea
                          solo
                          dense
                          v-model="conteudoCompartilhado[componente.id]"
                          :error-messages="errors"
                          :maxlength="4000"
                          :counter="true"
                        >
                          <template v-slot:counter>
                            {{ (conteudoCompartilhado[componente.id] || "").length }}/4000
                          </template>
                        </v-textarea>
                      </ValidationProvider>
                    </template>
                  </v-card>

                  <template v-else>
                    <v-tabs
                      v-model="abaAtiva"
                      background-color="transparent"
                      color="primary"
                      grow
                      class="mt-2"
                    >
                      <v-tab v-for="h in horariosSelecionados" :key="h.id">
                        {{ h.descricao }}
                      </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="abaAtiva">
                      <v-tab-item v-for="h in horariosSelecionados" :key="h.id" eager>
                        <v-card outlined class="pa-3 mt-2">
                          <strong>Componentes curriculares de {{ h.descricao }}</strong>
                          <div
                            v-if="componentesDoHorario(h.id).some((c) => !c.extra_curricular)"
                            class="text-caption grey--text mt-1 mb-2"
                          >
                            Não é possível selecionar mais de um componente curricular não
                            complementar por horário.
                          </div>
                          <div
                            v-if="!componentesDoHorario(h.id).length"
                            class="text-caption grey--text mt-2"
                          >
                            Nenhum componente curricular vinculado a esse horário na grade.
                          </div>
                          <div
                            v-for="componente in componentesDoHorario(h.id)"
                            :key="componente.id"
                          >
                            <v-checkbox
                              :input-value="
                                (componentesPorHorario[h.id] || []).includes(componente.id)
                              "
                              :disabled="
                                !componente.extra_curricular &&
                                temNaoComplementarExcetoId(
                                  componentesPorHorario[h.id] || [],
                                  componentesDoHorario(h.id),
                                  componente.id
                                )
                              "
                              :label="componente.descricao"
                              hide-details
                              @change="(v) => alternarComponenteDoHorario(h.id, componente.id, v)"
                            />
                          </div>

                          <template
                            v-for="componente in componentesSelecionadosObjs(
                              componentesDoHorario(h.id),
                              componentesPorHorario[h.id] || []
                            )"
                          >
                            <ValidationProvider
                              :key="componente.id"
                              :vid="`conteudo-${h.id}-${componente.id}`"
                              :name="`Conteúdo de ${componente.descricao} em ${h.descricao}`"
                              rules="required|no_special_chars"
                              v-slot="{ errors }"
                            >
                              <e-label class="mt-2">Conteúdo de {{ componente.descricao }}</e-label>
                              <v-textarea
                                solo
                                dense
                                v-model="conteudoPorHorario[h.id][componente.id]"
                                :error-messages="errors"
                                :maxlength="4000"
                                :counter="true"
                              >
                                <template v-slot:counter>
                                  {{ (conteudoPorHorario[h.id][componente.id] || "").length }}/4000
                                </template>
                              </v-textarea>
                            </ValidationProvider>
                          </template>
                        </v-card>
                      </v-tab-item>
                    </v-tabs-items>
                  </template>

                  <ValidationProvider
                    v-if="horariosSelecionados.length"
                    name="Metodologia"
                    rules="required|no_special_chars"
                    v-slot="{ errors }"
                  >
                    <e-label class="mt-2">Metodologia</e-label>
                    <v-textarea
                      id="aulaSelecionada.metodologia"
                      solo
                      dense
                      v-model="aulaSelecionada.metodologia"
                      :error-messages="errors"
                      :maxlength="4000"
                      :counter="true"
                    >
                      <template v-slot:counter>
                        {{ (aulaSelecionada.metodologia || "").length }}/4000
                      </template>
                    </v-textarea>
                  </ValidationProvider>
                </template>
              </template>

              <!-- EDIÇÃO polivalente (formato legado): mantém a UI existente -->
              <template v-else>
                <e-label>Conteúdos</e-label>
                <v-card
                  v-for="(item, index) in arrayConteudos"
                  :key="index"
                  class="mx-auto my-1 col-12"
                >
                  <strong>{{ getNomeDisciplina(item.id) }}</strong>
                  <ValidationProvider
                    :vid="`conteudo-edit-${index}`"
                    :name="`Conteúdo de ${getNomeDisciplina(item.id)}`"
                    rules="required|no_special_chars"
                    v-slot="{ errors }"
                  >
                    <v-textarea
                      solo
                      dense
                      v-model="arrayConteudos[index].content"
                      :error-messages="errors"
                      :maxlength="4000"
                      :counter="true"
                    >
                      <template v-slot:counter>
                        {{ (arrayConteudos[index].content || "").length }}/4000
                      </template>
                    </v-textarea>
                  </ValidationProvider>

                  <div>
                    <div class="mb-5">
                      <ul v-if="horariosDefinidos?.find((x) => x?.id === item?.id)?.array">
                        <div
                          v-for="(item, ind) in horariosDefinidos?.find((x) => x?.id === item?.id)
                            ?.array"
                          :key="ind"
                        >
                          <li>{{ getObjHorario(item) }}</li>
                        </div>
                      </ul>
                      <v-btn @click="editarHorario = index">Alterar Horário</v-btn>
                    </div>
                  </div>

                  <template v-if="editarHorario === index">
                    <ValidationProvider name="horario" rules="required" v-slot="{ errors }">
                      <e-autocomplete
                        :disabled="aulaSelecionada.data ? false : true"
                        :items="horariosDoDiaParaDisciplina(diaDaSemanaAtual, item.id)"
                        multiple
                        label="Selecione"
                        :item-text="(item) => item.descricao"
                        v-model="horarios_selecionados_extras[item.id]"
                        return-object
                        dense
                        @change="
                          ($event) => {
                            verifyHorariosSelectExtra($event, item.id, $event);
                          }
                        "
                        :error-messages="errors"
                      />
                    </ValidationProvider>
                  </template>
                </v-card>

                <ValidationProvider
                  name="Metodologia"
                  rules="required|no_special_chars"
                  v-slot="{ errors }"
                >
                  <e-label>Metodologia</e-label>
                  <v-textarea
                    id="aulaSelecionada.metodologia"
                    solo
                    dense
                    v-model="aulaSelecionada.metodologia"
                    :error-messages="errors"
                    :maxlength="4000"
                    :counter="true"
                  >
                    <template v-slot:counter>
                      {{ (aulaSelecionada.metodologia || "").length }}/4000
                    </template>
                  </v-textarea>
                </ValidationProvider>
              </template>

              <v-btn
                id="aulaSelecionada.submit"
                color="primary"
                :disabled="submittingForm"
                :loading="submittingForm"
                type="submit"
                @click="tipoEnvio = 'salvar'"
                >Enviar Dados</v-btn
              >
              <v-btn
                id="aulaSelecionada.submit-frequencia"
                v-if="!editing"
                class="ml-3"
                color="teal darken-1"
                dark
                :disabled="submittingForm"
                :loading="submittingForm"
                type="submit"
                @click="tipoEnvio = 'frequencia'"
                >Enviar Dados e Lançar Frequência</v-btn
              >
              <v-btn
                id="aulaSelecionada.duplicar"
                v-if="editing && outrosCampos"
                class="ml-3"
                color="success"
                @click="dialog.duplicar = true"
                >Duplicar Aula</v-btn
              >
              <v-btn
                id="aulaSelecionada.exportar"
                v-if="editing && outrosCampos"
                class="ml-3"
                color="success"
                @click="dialog.exportar = true"
                >Exportar Aula</v-btn
              >
            </v-col>
          </v-row>
        </div>
        <v-row v-if="etapas?.length === 0 && etapaBloqueada == false">
          <v-col cols="12">
            <v-alert type="warning" border="left">
              Não existem etapas disponíveis para a data atual
            </v-alert>
          </v-col>
        </v-row>
        <v-row v-if="etapaBloqueada == true && etapaPendente == false">
          <v-col cols="12">
            <v-alert :class="avisoAnime" type="warning" border="left">
              Atenção essa etapa está bloqueada, para lançar aulas você deve solicitar uma
              autorização, clicando no botão acima
            </v-alert>
          </v-col>
        </v-row>
        <v-row v-if="etapaPendente == true">
          <v-col cols="12">
            <v-alert :class="avisoAnime" type="warning" border="left">
              Aguarde, já existe um pedido de autorização para essa etapa e estamos analisando.
            </v-alert>
            <v-btn id="aulaSelecionada.ver-pedidos" class="success" @click="verPedidos"
              >Acompanhe seus pedidos</v-btn
            >
          </v-col>
        </v-row>

        <div
          v-if="
            etapas?.length > 0 &&
            etapaBloqueada == false &&
            etapaSelecionada &&
            etapaPendente == false
          "
        >
          <v-row v-if="!aulaSelecionada.tipo_de_aula || !aulaSelecionada.data">
            <v-col cols="12" v-if="aulaSelecionada.tipo_de_aula !== 'Aula Remota'">
              <v-alert type="warning" border="left"> Por favor, preencha todos os campos! </v-alert>
            </v-col>
          </v-row>
        </div>
      </form>

      <v-bottom-sheet v-model="aulasEmConflitos" scrollable persistent>
        <v-sheet class="text-center pa-md-8 mx-lg-auto" height="auto">
          <!-- <v-btn color="error" dark small @click="aulasEmConflitos = !aulasEmConflitos">
                Fechar
              </v-btn> -->

          <v-btn
            id="aulaSelecionada.fechar-conflitos"
            color="error"
            dark
            small
            @click="aulasEmConflitos = !aulasEmConflitos"
          >
            Fechar
          </v-btn>
          <h2 class="mt-4">Aulas conflitadas</h2>
          <p class="mt-2 mb-0 text-body-2">
            Já existem aulas cadastradas para esta turma nos horários abaixo. Ajuste os horários
            selecionados antes de salvar.
          </p>
          <v-simple-table class="mt-4" style="border: 1px solid #e0e0e0">
            <template>
              <thead style="background-color: #e0e0e0">
                <tr>
                  <th class="text-left">#</th>
                  <th class="text-left">Professor</th>
                  <th class="text-left">Situação</th>
                  <th class="text-left">Data/Horário</th>
                  <th class="text-left">Turma</th>
                  <th class="text-left">Disciplina</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(conflito, i) in aulasConflitadas" :key="i">
                  <td>{{ conflito.id ?? "- - -" }}</td>
                  <td>
                    {{ conflito.instrutor ?? "- - -" }}
                    <br />
                    <v-chip color="grey" dark x-small>
                      {{ conflito.franquia ?? "- - -" }}
                    </v-chip>
                  </td>
                  <td>{{ conflito.situacao ? conflito.situacao : "Aguardando" }}</td>
                  <td>
                    <span>{{
                      (conflito.data || "").slice(0, 10).split("-").reverse().join("/")
                    }}</span>
                    <span> - {{ conflito.horario ?? "- - -" }} </span>
                  </td>
                  <td>{{ conflito.turma ?? "- - -" }}</td>
                  <td>{{ conflito.disciplina_descricao ?? "- - -" }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-sheet>
      </v-bottom-sheet>
    </ValidationObserver>
    <v-alert text border="left" color="orange" icon="warning" class="text-caption" v-else
      >Atenção, essa turma ainda não foi vinculada a um circuito, para fazer isso você tem que ir em
      Turmas->Editar e Selecione o Circuito desejado, caso seja um professor aguarde o responsável
      realizar esse procedimento.</v-alert
    >
    <e-modal-duplicar-aula-polivalencia
      v-if="aulaSelecionada.disciplinas"
      :submittingForm="submittingForm"
      :dialog="dialog.duplicar"
      :gestaoDeAulas="aulaSelecionada"
      :form="{ ...aulaSelecionada }"
      :allowedDates="allowedDates"
      :horarios="horarios"
      :disciplinas="aulaSelecionada.disciplinas"
      @dialogChange="dialog.duplicar = $event"
    >
    </e-modal-duplicar-aula-polivalencia>
    <e-modal-duplicar-aula
      v-else
      :submittingForm="submittingForm"
      :dialog="dialog.duplicar"
      :gestaoDeAulas="aulaSelecionada"
      :form="{ ...aulaSelecionada }"
      :allowedDates="allowedDates"
      :horarios="horarios"
      @dialogChange="dialog.duplicar = $event"
    >
    </e-modal-duplicar-aula>
    <!-- <e-modal-exportar-aula
      :submittingForm="submittingForm"
      :dialog="dialog.exportar"
      :form="{ ...aulaSelecionada }"
      :allowedDates="allowedDates"
      @dialogChange="dialog.exportar = $event"
      :horarios="horarios"
    >
    </e-modal-exportar-aula> -->
    <e-modal-exportar-aula-polivalencia
      :submittingForm="submittingForm"
      :dialog="dialog.exportar"
      :form="{ ...aulaSelecionada }"
      :allowedDates="allowedDates"
      @dialogChange="dialog.exportar = $event"
      :horarios="horarios"
    >
    </e-modal-exportar-aula-polivalencia>
  </main-template>
</template>

<script>
import ELabel from "../../components/ELabel.vue";
import { dateFormatParam } from "../../plugins/filters";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    aula_id: {
      type: Number,
      require: true,
    },
  },
  computed: {
    tipo_de_aula() {
      return this.aulaSelecionada.tipo_de_aula;
    },
    // Horários do dia da semana atual que têm ao menos um componente curricular vinculado na
    // grade (Vínculo de Dias e Horários da gestão) — em sábado letivo, a grade não se aplica
    // (é um dia especial fora do padrão semanal), então libera todos os horários da rede.
    horariosDoDiaAtual() {
      if (this.ehSabadoLetivoAtual) {
        return this.todosHorariosDisponiveis || [];
      }
      if (this.diaDaSemanaAtual === null || !this.grade) return [];
      const idsComComponente = new Set(
        (this.grade.celulas || [])
          .filter(
            (c) => c.dia_id === this.diaDaSemanaAtual && c.disciplinas && c.disciplinas.length
          )
          .map((c) => c.horario_id)
      );
      return (this.todosHorariosDisponiveis || []).filter((h) => idsComComponente.has(h.id));
    },
    // Só 1 horário selecionado, ou "Replicar Conteúdo" ligado: usa uma única seleção de
    // componentes/conteúdo compartilhada entre todos os horários, em vez de abas
    // independentes (Regra "Impedir seleção de Replicar Conteúdo", #7530).
    usarSelecaoCompartilhada() {
      return this.replicarConteudo || this.horariosSelecionados.length <= 1;
    },
    // Componentes válidos em TODOS os horários selecionados ao mesmo tempo — garante que a
    // seleção compartilhada faça sentido em qualquer um deles.
    componentesCompartilhadosDisponiveis() {
      if (!this.horariosSelecionados.length) return [];
      const [primeira, ...resto] = this.horariosSelecionados.map((h) =>
        this.componentesDoHorario(h.id)
      );
      return (primeira || []).filter((c) =>
        resto.every((lista) => lista.some((c2) => c2.id === c.id))
      );
    },
    // Trava o switch quando não há como replicar: com mais de 1 horário selecionado e
    // nenhum componente comum a todos eles, ligar o switch só levaria a um painel vazio.
    semComponenteCurricularComum() {
      return (
        this.horariosSelecionados.length > 1 && !this.componentesCompartilhadosDisponiveis.length
      );
    },
    // Componentes presentes em ALGUNS horários selecionados, mas não em TODOS — usado pra
    // nomear o motivo específico de "Replicar Conteúdo" estar bloqueado, em vez de um
    // "nenhum é comum" genérico que esconde coincidências parciais (ex.: um componente em 2
    // dos 3 horários selecionados).
    componentesNaoComunsATodos() {
      if (this.horariosSelecionados.length < 2) return [];
      const listas = this.horariosSelecionados.map((h) => this.componentesDoHorario(h.id));
      const total = listas.length;
      const infoPorId = new Map();
      listas.forEach((lista) => {
        lista.forEach((c) => {
          const atual = infoPorId.get(c.id) || { descricao: c.descricao, count: 0 };
          atual.count += 1;
          infoPorId.set(c.id, atual);
        });
      });
      return [...infoPorId.values()].filter((item) => item.count < total);
    },
    mensagemSemComponenteComum() {
      const itens = this.componentesNaoComunsATodos;
      if (!itens.length) {
        return "Nenhum componente curricular é comum a todos os horários selecionados — não é possível replicar.";
      }
      const total = this.horariosSelecionados.length;
      const nomes = itens.map((c) => `${c.descricao} (${c.count} de ${total} horários)`).join(", ");
      const verbo = itens.length > 1 ? "fazem" : "faz";
      return `${nomes} não ${verbo} parte de todos os horários selecionados — por isso não é possível replicar.`;
    },
    eventosFiltradosPorMes() {
      if (!this.mesVisivel) return [];
      return (this.todosEventos || [])
        .filter((evento) => evento.data.startsWith(this.mesVisivel))
        .sort((a, b) => {
          return parseInt(a.data.split("-")[2], 10) - parseInt(b.data.split("-")[2], 10);
        });
    },
  },
  mounted() {
    this.loadData();
    if (this.editing) {
      this.mostrarCampos = true;
      this.outrosCampos = true;
    }
    this.carregarFeriados();
  },
  data() {
    return {
      diasPermitidosParaCriarAula: [0, 1, 2, 3, 4, 5, 6],
      arrayIdsHorarios: [],
      horarioComConflito: null,
      disciplinaComConflito: null,
      checkHorarioExtra: [],
      array_horarios_extras: [],
      horarios_selecionados_extras: [],
      conteudos: [],
      horarios_selecionados: [],
      arrayConteudos: [],
      text: "",
      textColor: "#000000",
      // Criação polivalente (#7530): contexto do dia (recalculado a cada troca de data) +
      // estado da seleção "horário → componentes". grade vem de gradeHorarios(gestaoId) e
      // carrega, por dia+horário, quais componentes são válidos ali (com extra_curricular).
      diaDaSemanaAtual: null,
      ehSabadoLetivoAtual: false,
      grade: null,
      horariosSelecionados: [],
      abaAtiva: 0,
      replicarConteudo: false,
      // componentesPorHorario[horarioId] = [disciplinaId, ...] — independente por horário.
      componentesPorHorario: {},
      // conteudoPorHorario[horarioId][disciplinaId] = texto do conteúdo.
      conteudoPorHorario: {},
      // Usados só quando usarSelecaoCompartilhada === true (replicar ligado, ou 1 horário só).
      componentesCompartilhados: [],
      conteudoCompartilhado: {},
      tipoEnvio: "salvar",
      avisoAnime: "",
      etapaPendente: false,
      etapaBloqueada: false,
      idsEtapasDisponivels: [],
      idsEtapasPendentes: [],
      autorizacao: [],
      mostrarEtapas: false,
      fimPeriodoEtapa: null,
      inicioPeriodoEtapa: null,
      etapaSelecionada: null,
      etapas: null,
      turma: null,
      data: null,
      modal: false,
      aulasEmConflitos: false,
      aulasConflitadas: [],
      mostrarCampos: false,
      outrosCampos: false,
      submittingForm: false,
      form: {},
      aulaSelecionada: {
        data: null,
      },
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
      },
      aulaDuplicada: {},
      gestaoDeAulas: null,
      dialog: {
        duplicar: false,
        exportar: false,
      },
      horarios: [],
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      arrayConteudoEditar: [],
      arrayHorarios: [],
      arrayHorariosEditar: [],
      editarHorario: null,
      horariosAll: [],
      horariosDefinidos: [],
      arrayHorariosMarcados: [],
      mesVisivel: null,
      todosEventos: [],
      feriados: [],
      eventos: [],
      sabadosLetivos: [],
      diasLetivos: [],
      diasNaoLetivos: [],
      turmaComConflito: null,
      franquiaConflito: null,
      instrutorConflito: null,
      aulaConflitoSituacao: null,
    };
  },
  watch: {
    modal(val) {
      if (val) {
        this.$nextTick(() => this.aplicarIdDatePicker());
      }
    },
    horarios_selecionados_extras(old, novo) {},

    checkHorarioExtra(val) {},
    // Mantém componentesPorHorario/conteudoPorHorario só com entradas dos horários
    // atualmente selecionados — remove abas que saíram da seleção, inicializa as que
    // entraram (Cenário "Disponibilizar uma aba para cada horário selecionado", #7530).
    horariosSelecionados(novo) {
      const idsSelecionados = new Set((novo || []).map((h) => h.id));

      Object.keys(this.componentesPorHorario).forEach((id) => {
        if (!idsSelecionados.has(Number(id))) {
          this.$delete(this.componentesPorHorario, id);
          this.$delete(this.conteudoPorHorario, id);
        }
      });

      (novo || []).forEach((h) => {
        if (!this.componentesPorHorario[h.id]) this.$set(this.componentesPorHorario, h.id, []);
        if (!this.conteudoPorHorario[h.id]) this.$set(this.conteudoPorHorario, h.id, {});
      });

      if (this.abaAtiva >= (novo || []).length) this.abaAtiva = 0;
    },
    // Ao alternar "Replicar Conteúdo", limpa os campos preenchidos (tanto o modo por abas
    // quanto o compartilhado) — evita levar uma seleção feita num modo para o outro, onde
    // pode não fazer sentido (Regra "Impedir seleção de Replicar Conteúdo", #7530).
    replicarConteudo() {
      this.componentesPorHorario = {};
      this.conteudoPorHorario = {};
      this.componentesCompartilhados = [];
      this.conteudoCompartilhado = {};
      (this.horariosSelecionados || []).forEach((h) => {
        this.$set(this.componentesPorHorario, h.id, []);
        this.$set(this.conteudoPorHorario, h.id, {});
      });
    },
    // Se a seleção de horários mudar de um jeito que quebre a interseção de componentes
    // enquanto "Replicar Conteúdo" já está ligado, desliga sozinho — senão o switch ficaria
    // desabilitado e ligado ao mesmo tempo, sem jeito de desligar pela tela — e avisa o motivo.
    semComponenteCurricularComum(semComponente) {
      if (semComponente && this.replicarConteudo) {
        this.replicarConteudo = false;
        this.$toast.warn(`Replicar Conteúdo foi desligado. ${this.mensagemSemComponenteComum}`);
      }
    },
    tipo_de_aula() {
      if (this.aulaSelecionada.tipo_de_aula === "Aula Remota") {
        this.aulaSelecionada.horario_inicial = null;
        this.aulaSelecionada.horario_final = null;
        this.horarioSelecionado = null;
        this.mostrarCampos = true;
        this.outrosCampos = true;
      } else if (this.aulaSelecionada.tipo_de_aula) {
        this.mostrarCampos = true;
        this.outrosCampos = true;
      } else {
        this.mostrarCampos = false;
        this.outrosCampos = false;
      }
    },
    data(value) {
      if (!value) return;
      const data_old = new Intl.DateTimeFormat("pt-BR", {
        timeZone: "UTC",
      }).format(new Date(value));
      this.aulaSelecionada.data = data_old.replaceAll("/", "/");
      this.atualizarContextoDoDia(new Date(value).getDay(), value);
    },
  },
  methods: {
    allowedDates(val) {
      let dataFormatada;
      if (typeof val === "string") {
        dataFormatada = val.length > 10 ? val.slice(0, 10) : val;
      } else {
        dataFormatada = new Date(val).toISOString().split("T")[0];
      }

      const evento = (this.todosEventos || []).find((ev) => {
        const evData = ev.data.length > 10 ? ev.data.slice(0, 10) : ev.data;
        return evData === dataFormatada;
      });
      if (evento) {
        if (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1) {
          return true;
        }
        return false;
      }
      const ehFeriado = this.feriados.some((feriado) => {
        const fData = feriado.data.length > 10 ? feriado.data.slice(0, 10) : feriado.data;
        return fData === dataFormatada;
      });
      if (ehFeriado) return true;

      const diaDaSemana = new Date(dataFormatada).getDay();
      if (!this.diasPermitidosParaCriarAula.includes(diaDaSemana)) return false;

      return true;
    },
    async buscarTodosHorarios() {
      try {
        const response = await this.$services.gestoesDeAulasService.getAllHorarios();
        const horariosData = response.data || response;
        this.todosHorariosDisponiveis = horariosData.map((h) => ({
          id: h.id,
          turno_id: h.turno_id,
          descricao: h.descricao || "Horário",
          final: h.final,
          inicio: h.inicio,
        }));

        return this.todosHorariosDisponiveis;
      } catch (error) {
        this.$handleError(error);
        return [];
      }
    },
    toYMD(v) {
      if (!v) return "";
      if (typeof v === "string") return v.length > 10 ? v.slice(0, 10) : v;
      const d = v instanceof Date ? v : new Date(v);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
        d.getDate()
      ).padStart(2, "0")}`;
    },
    // Todos os horários do dia, sem considerar disciplina — usado só na inicialização do
    // modo edição (this.horarios), antes de saber qual disciplina específica está sendo
    // alterada.
    horariosDoDia(diaDaSemana) {
      const vistos = new Set();
      return (this.gestaoDeAula?.relacoesDiasHorarios || [])
        .filter((r) => r.dia.id === diaDaSemana)
        .map((r) => r.horario)
        .filter((horario) => {
          if (vistos.has(horario.id)) return false;
          vistos.add(horario.id);
          return true;
        });
    },
    // Mesma ideia, mas só os horários vinculados a UMA disciplina específica na grade —
    // usado no "Alterar Horário" (edição, formato legado), pra não deixar escolher um
    // horário que na grade pertence a outra disciplina.
    horariosDoDiaParaDisciplina(diaDaSemana, disciplinaId) {
      const vistos = new Set();
      return (this.gestaoDeAula?.relacoesDiasHorarios || [])
        .filter((r) => r.dia.id === diaDaSemana && r.disciplina && r.disciplina.id === disciplinaId)
        .map((r) => r.horario)
        .filter((horario) => {
          if (vistos.has(horario.id)) return false;
          vistos.add(horario.id);
          return true;
        });
    },
    // Componentes curriculares válidos para um horário específico do dia atualmente
    // selecionado, com extra_curricular (vindo de gradeHorarios(), a mesma fonte usada na
    // grade "Vínculo de Dias e Horários" da gestão). Em sábado letivo a grade não se aplica
    // (dia especial fora do padrão semanal) — libera todos os componentes vinculados à
    // gestão, igual ao comportamento já existente para horários nesse caso.
    componentesDoHorario(horarioId) {
      if (this.ehSabadoLetivoAtual) {
        return this.grade?.componentes || [];
      }
      const celula = (this.grade?.celulas || []).find(
        (c) => c.dia_id === this.diaDaSemanaAtual && c.horario_id === horarioId
      );
      return celula?.disciplinas || [];
    },
    // Um horário só pode ter 1 componente NÃO complementar — usado para desabilitar os
    // demais não-complementares assim que um já está marcado (Regra "Validação de conflito
    // com componente curricular não complementar", #7530).
    temNaoComplementarExcetoId(idsSelecionados, componentesDisponiveis, exceptId) {
      return idsSelecionados.some((id) => {
        if (id === exceptId) return false;
        const componente = componentesDisponiveis.find((c) => c.id === id);
        return componente && !componente.extra_curricular;
      });
    },
    componentesSelecionadosObjs(componentesDisponiveis, idsSelecionados) {
      return componentesDisponiveis.filter((c) => idsSelecionados.includes(c.id));
    },
    alternarComponenteDoHorario(horarioId, componenteId, marcado) {
      const atual = this.componentesPorHorario[horarioId] || [];
      const novo = marcado ? [...atual, componenteId] : atual.filter((id) => id !== componenteId);
      this.$set(this.componentesPorHorario, horarioId, novo);

      if (!this.conteudoPorHorario[horarioId]) this.$set(this.conteudoPorHorario, horarioId, {});
      if (!(componenteId in this.conteudoPorHorario[horarioId])) {
        this.$set(this.conteudoPorHorario[horarioId], componenteId, "");
      }
    },
    alternarComponenteCompartilhado(componenteId, marcado) {
      this.componentesCompartilhados = marcado
        ? [...this.componentesCompartilhados, componenteId]
        : this.componentesCompartilhados.filter((id) => id !== componenteId);

      if (!(componenteId in this.conteudoCompartilhado)) {
        this.$set(this.conteudoCompartilhado, componenteId, "");
      }
    },
    // Modo edição: popula this.horarios/horariosDoComponente (usado só em "Alterar Horário",
    // a aula já tem disciplinas fixas então não há filtro por disciplina aqui).
    async filtrarHorariosPorDiaDaSemana(diaDaSemana, dataSelecionada = this.data) {
      const dataFormatada = this.toYMD(dataSelecionada);
      const evento = (this.todosEventos || []).find((ev) => this.toYMD(ev.data) === dataFormatada);
      const ehSabadoLetivo = !!(
        evento &&
        (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1)
      );

      if (evento) {
        if (ehSabadoLetivo) {
          if (!this.todosHorariosDisponiveis || this.todosHorariosDisponiveis.length === 0) {
            await this.buscarTodosHorarios();
          }

          this.horarios = this.todosHorariosDisponiveis || [];
          this.horariosDoComponente = this.todosHorariosDisponiveis.map((h) => ({
            id: h.id,
            descricao: h.descricao ? h.descricao.split(" - ")[0] : "Horário",
            inicio: h.inicio,
            final: h.final,
            turno_id: h.turno_id,
          }));
          return;
        }

        if (evento.is_letivo === true || evento.is_letivo === 1) {
          const horariosDoDia = this.horariosDoDia(diaDaSemana);
          this.horarios = horariosDoDia;
          this.horariosDoComponente = horariosDoDia;
          return;
        }
        if (!this.editing) {
          this.horarios = [];
          this.horariosDoComponente = [];
        }
        return;
      }

      if (!this.gestaoDeAula?.relacoesDiasHorarios) {
        this.horarios = [];
        this.horariosDoComponente = [];
        return;
      }

      const horariosDoDia = this.horariosDoDia(diaDaSemana);
      this.horarios = horariosDoDia;
      this.horariosDoComponente = horariosDoDia;
    },
    // Modo criação: recalcula o contexto do dia (dia da semana + sábado letivo) usado por
    // horariosDoDiaAtual/componentesDoHorario. Os horários válidos mudam com a data, então a
    // seleção anterior é limpa (o watcher de horariosSelecionados já limpa
    // componentesPorHorario/conteudoPorHorario em cascata).
    async atualizarContextoDoDia(diaDaSemana, dataSelecionada) {
      const dataFormatada = this.toYMD(dataSelecionada);
      const evento = (this.todosEventos || []).find((ev) => this.toYMD(ev.data) === dataFormatada);
      const ehSabadoLetivo = !!(
        evento &&
        (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1)
      );

      this.diaDaSemanaAtual = diaDaSemana;
      this.ehSabadoLetivoAtual = ehSabadoLetivo;

      if (
        ehSabadoLetivo &&
        (!this.todosHorariosDisponiveis || this.todosHorariosDisponiveis.length === 0)
      ) {
        await this.buscarTodosHorarios();
      }

      this.horariosSelecionados = [];
      this.replicarConteudo = false;
    },
    async carregarFeriados() {
      try {
        const response = await this.$services.calendarioLetivoService.syncAll();
        this.todosEventos = response.map((evento) => ({
          data: evento.start.length > 10 ? evento.start.slice(0, 10) : evento.start,
          descricao: evento.descricao,
          cor: evento.color,
          is_feriado: evento.evento.is_feriado,
          is_sabado_letivo: evento.evento.is_sabado_letivo,
          is_letivo: evento.evento.is_letivo,
        }));
        this.feriados = this.todosEventos.filter((evento) => evento.is_feriado === true);
        this.sabadosLetivos = this.todosEventos.filter(
          (evento) => evento.is_sabado_letivo === true
        );
        this.diasLetivos = this.todosEventos.filter(
          (ev) =>
            ev.is_sabado_letivo === true ||
            ev.is_sabado_letivo === 1 ||
            ev.is_letivo === true ||
            ev.is_letivo === 1
        );
        this.diasNaoLetivos = this.todosEventos.filter(
          (ev) => !ev.is_sabado_letivo && !ev.is_letivo && !ev.is_feriado
        );
      } catch (error) {
        this.$handleError(error);
      }
    },
    atualizarMesVisivel(pickerDate) {
      const [ano, mes] = pickerDate.split("-");
      this.mesVisivel = `${ano}-${mes}`;
      this.$nextTick(() => this.aplicarIdDatePicker());
    },
    aplicarIdDatePicker() {
      const picker = this.$refs.datePicker?.$el;
      if (!picker) return;
      const headerBtns = picker.querySelectorAll(".v-date-picker-header .v-btn");
      if (headerBtns[0]) headerBtns[0].id = "date-picker.prev-mes";
      if (headerBtns[1]) headerBtns[1].id = "date-picker.header-mes";
      if (headerBtns[2]) headerBtns[2].id = "date-picker.next-mes";
      if (!this.mesVisivel) return;
      const [ano, mes] = this.mesVisivel.split("-");
      picker.querySelectorAll(".v-date-picker-table button").forEach((btn) => {
        const content = btn.querySelector(".v-btn__content");
        if (!content) return;
        const dia = content.textContent.trim();
        if (!dia || isNaN(parseInt(dia, 10))) return;
        btn.id = `date-picker.dia-${ano}-${mes}-${dia.padStart(2, "0")}`;
      });
    },
    formatarDia(data) {
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}`;
    },
    getEventColor(date) {
      const feriado = this.feriados.find((f) => f.data === date);
      if (feriado) return feriado.cor || "red";
      const letivo = this.diasLetivos.find((l) => l.data === date);
      if (letivo) return letivo.cor || "green";
      const bloqueio = this.diasNaoLetivos && this.diasNaoLetivos.find((d) => d.data === date);
      if (bloqueio) return bloqueio.cor || "red";
      return "primary";
    },
    getHorariosDaAula(aula) {
      const horariosFiltrados = [];

      const horariosDaAulaExtra = JSON.parse(aula?.horarios_extras) || [];

      return horariosDaAulaExtra;
    },

    valoresComuns(array1, array2) {
      return array1.filter((valor) => array2.includes(valor));
    },
    verifyHorariosSelectExtra(item, IDdisciplina) {
      const ids = (item || []).map((element) => element.id);
      const disciplina = this.array_horarios_extras.find((it) => it.id === IDdisciplina);

      if (disciplina) {
        disciplina.array = ids;
      } else {
        this.array_horarios_extras.push({ id: IDdisciplina, array: ids });
      }
    },

    removerValorDoArray(valor) {
      let horarios = this.horarios;
      horarios = horarios.filter((item) => item.id !== valor.id);
    },

    getNomeDisciplina(id) {
      // eslint-disable-next-line eqeqeq
      const dis = this.gestaoDeAula.disciplinas?.filter((obj) => obj.id == id);
      return dis?.[0]?.descricao ?? "—";
    },
    getObjHorario(id) {
      if (id) {
        const dis = this.horarios.filter((obj) => obj.id === id);
        return dis[0]?.descricao || "Horário não encontrado";
      }
    },
    editarConteudoPoli(index, $event) {
      this.arrayConteudos[index] = $event;
    },
    editarHorarioPoli(index, $event) {
      this.arrayHorarios[index] = $event;
    },
    getConteudoPolivalencia() {
      if (!this.aulaSelecionada.disciplinas || !Array.isArray(this.aulaSelecionada.disciplinas)) {
        this.arrayConteudoEditar = [];
        return;
      }

      this.aulaSelecionada.disciplinas.forEach((element, index) => {
        const conteudoPolivalencia = JSON.parse(this.aulaSelecionada.conteudo_polivalencia || "[]");
        this.arrayConteudoEditar.push(conteudoPolivalencia[index]);
      });

      this.arrayConteudoEditar.forEach((element, index) => {
        const obj = {
          id: this.aulaSelecionada.disciplinas[index],
          content: element,
        };
        this.arrayConteudos.push(obj);
      });
    },
    getHorariosPolivalencia(id) {
      return this.horarios.filter((item) => item.id === id);
    },
    atualizarTopicos(array) {
      this.arrayConteudos = [];
      array.forEach((element) => {
        this.arrayConteudos.push(element);
      });
    },
    updateText(event) {
      this.text = event.target.innerHTML;
    },
    executeCommand(command) {
      document.execCommand(command, false, null);
    },

    changeFont(size) {
      document.execCommand("fontSize", false, "7");
      const sel = window.getSelection();
      if (sel.rangeCount) {
        const range = sel.getRangeAt(0);
        const node = document.createElement("span");
        node.style.fontSize = size;
        range.surroundContents(node);
      }
    },
    changeStyle(style) {
      document.execCommand(style, false, null);
      const sel = window.getSelection();
      if (sel.rangeCount) {
        const range = sel.getRangeAt(0);
        const node = document.createElement("span");
        node.style.fontStyle = style === "italic" ? style : null;
        node.style.fontWeight = style === "bold" ? style : null;
        node.style.textDecoration = style === "underline" ? style : null;
        range.surroundContents(node);
      }
    },
    setTextColor() {
      this.executeCommand("foreColor", this.textColor);
    },
    animarAviso() {
      this.avisoAnime = "animate__animated animate__headShake";
      setTimeout(() => (this.avisoAnime = ""), 500);
    },
    dateFormatConvert(data) {
      return dateFormatParam(data);
    },
    verificarEtapaSelecionada() {
      this.aulaSelecionada.data = null;
      this.horariosDefinidos = null;
      // this.horarios = null;
      // this.array_horarios_extras = null;

      this.animarAviso();
      this.inicioPeriodoEtapa = this.etapas
        .filter((d) => d.id === this.etapaSelecionada.id)
        .shift().periodo_inicial;
      this.inicioPeriodoEtapa = dateFormatParam(this.inicioPeriodoEtapa, "y-m-d");
      this.fimPeriodoEtapa = this.etapas
        .filter((d) => d.id === this.etapaSelecionada.id)
        .shift().periodo_final;
      this.fimPeriodoEtapa = dateFormatParam(this.fimPeriodoEtapa, "y-m-d");

      const etapaVerificar = this.etapas.filter((d) => d.id === this.etapaSelecionada.id).shift();

      this.verificarSeEtapaEstaDisp(etapaVerificar);
    },
    async pesquisaAulas(horarioId, disciplinaId) {
      const data_aula = this.aulaSelecionada.data.split("/").reverse().join("-");
      // /* eslint-disable */
      const { aula_id } = this.$route.params;
      const turma_id = this.gestaoDeAula.turma.id;
      if (!data_aula || !horarioId || !this.aulaSelecionada) return;

      const response = await this.$services.aulasService.pesquisarAulasEmConflitosPoli(
        data_aula,
        horarioId,
        turma_id,
        aula_id
      );

      if (response.data.conflito) {
        const conflito = response.data.aulas[0];
        const aulaConflito = conflito.aula;
        const instrutorConflito = conflito.instrutor;
        const franquiaConflito = conflito.franquia;
        const aulaConflitoSituacao = conflito.situacao;
        const aula_id = conflito.id;
        const turmaComConflito = conflito.turma;
        const disciplinaNome = conflito.disciplina_descricao;
        const horarioConflito = conflito.horario;

        // this.horarioComConflito = this.horarios.find((item) => item.id === horarioId);

        this.aula_id = aula_id;
        this.franquiaConflito = instrutorConflito;
        this.instrutorConflito = instrutorConflito;
        this.aulaConflitoSituacao = aulaConflitoSituacao;
        this.disciplinaComConflito = disciplinaNome;
        this.turmaComConflito = turmaComConflito;
        this.horarioComConflito = horarioConflito;
        this.horarios_selecionados_extras[disciplinaId].pop();

        this.aulasEmConflitos = true;
      }
    },

    async verificaTipoDaAula() {
      if (this.aulaSelecionada.tipo_de_aula === "Aula Remota" || this.editing) {
        this.getAula();
        this.mostrarCampos = true;
        this.outrosCampos = true;
        return;
      }
      this.mostrarCampos = true;
      this.outrosCampos = false;
    },
    async editarHorarioIndividual(index, obj) {
      const horariosAula = JSON.parse(this.aulaSelecionada?.horarios);
      horariosAula[index] = obj.id;
      this.aulaSelecionada.data = this.aulaSelecionada.data.split("/").reverse().join("-");
      this.aulaSelecionada.horarios = JSON.stringify(horariosAula);

      await this.$services.aulasService.atualizar(this.aulaSelecionada);
      this.$toast.success("Horário editado com sucesso!");
      this.loadData();
      this.editarHorario = null;
    },
    async submitForm() {
      if (this.editing) {
        await this.salvarEdicaoAula();
      } else {
        await this.criarAulasPolivalentes();
      }
    },
    async salvarEdicaoAula() {
      const arrayParaEditar = this.arrayConteudos;
      arrayParaEditar.forEach((element, index) => {
        if (typeof element !== "string") {
          arrayParaEditar[index] = element.content;
        }
      });
      this.aulaSelecionada.conteudo_polivalencia = JSON.stringify(arrayParaEditar);
      this.aulaSelecionada.horarios_extras = JSON.stringify(this.array_horarios_extras);

      this.aulaSelecionada.horario_inicial = this.horarioSelecionado
        ? this.horarioSelecionado.inicio
        : null;
      this.aulaSelecionada.horario_final = this.horarioSelecionado
        ? this.horarioSelecionado.final
        : null;
      this.aulaSelecionada.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
      this.aulaSelecionada.etapa_id = this.etapaSelecionada.id;
      this.aulaSelecionada.instrutorDisciplinaTurma_id = parseInt(
        this.$route.params.gestaoDeAulaId,
        10
      );
      this.aulaSelecionada.data = this.aulaSelecionada.data.split("/").reverse().join("-");

      this.submittingForm = true;
      try {
        await this.$services.aulasService.atualizar(this.aulaSelecionada);
        this.$toast.success("Aula editada com sucesso!");
        this.$router.back();
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
    },
    // Monta 1 aula por horário selecionado — cada uma só com os componentes/conteúdo
    // configurados naquele horário (Regra "Criação das aulas por horário", #7530).
    // horarios_extras continua no formato "disciplina -> horários" só por compatibilidade
    // com os accessors do model Aula e com os modais de Exportar/Duplicar (que já leem esse
    // campo) — como cada aula agora tem exatamente 1 horário, cada disciplina aponta só pra
    // ele, o que já é uma leitura válida pra esse formato sem precisar mexer nesses modais.
    montarAulasParaCriar() {
      return this.horariosSelecionados.map((h) => {
        const componentesDesseHorario = this.usarSelecaoCompartilhada
          ? this.componentesCompartilhados
          : this.componentesPorHorario[h.id] || [];
        const conteudoDesseHorario = this.usarSelecaoCompartilhada
          ? this.conteudoCompartilhado
          : this.conteudoPorHorario[h.id] || {};

        const conteudosArray = componentesDesseHorario.map((id) => conteudoDesseHorario[id] || "");
        const horariosExtras = componentesDesseHorario.map((id) => ({ id, array: [h.id] }));

        return {
          disciplinas: [...componentesDesseHorario],
          conteudo_polivalencia: JSON.stringify(conteudosArray),
          horarios_extras: JSON.stringify(horariosExtras),
          horario_id: h.id,
          horario_inicial: h.inicio ?? null,
          horario_final: h.final ?? null,
          metodologia: this.aulaSelecionada.metodologia || "",
        };
      });
    },
    async criarAulasPolivalentes() {
      if (!this.horariosSelecionados.length) {
        this.$toast.warn("Selecione ao menos um horário.");
        return;
      }
      const horarioSemComponente = this.horariosSelecionados.find((h) => {
        const componentes = this.usarSelecaoCompartilhada
          ? this.componentesCompartilhados
          : this.componentesPorHorario[h.id] || [];
        return !componentes.length;
      });
      if (horarioSemComponente) {
        this.$toast.warn("Selecione ao menos um componente curricular para cada horário marcado.");
        return;
      }

      const payload = {
        aulas: this.montarAulasParaCriar(),
        data: this.aulaSelecionada.data.split("/").reverse().join("-"),
        etapa_id: this.etapaSelecionada.id,
        tipo_de_aula: this.aulaSelecionada.tipo_de_aula,
        instrutorDisciplinaTurma_id: parseInt(this.$route.params.gestaoDeAulaId, 10),
        turma_id: parseInt(this.gestaoDeAula.turma_id, 10),
        instrutor_id: parseInt(this.gestaoDeAula.instrutor_id, 10),
      };

      this.submittingForm = true;
      try {
        const response = await this.$services.aulasService.criarAula(payload);
        const resultados = Array.isArray(response.data) ? response.data : [response.data];

        // O backend revalida (server-side) o limite de 1 componente não complementar por
        // horário — um item que falhar volta com `errors` em vez de virar Aula, mesmo padrão
        // já usado em GestoesDeAulasController::criar.
        const comErro = resultados.filter((item) => item.errors);
        comErro.forEach((item) => {
          (item.errors || []).forEach((mensagem) => this.$toast.danger(mensagem));
        });
        const criadas = resultados.filter((item) => !item.errors);

        if (comErro.length && !criadas.length) {
          this.submittingForm = false;
          return;
        }

        if (this.tipoEnvio === "frequencia") {
          const ids = criadas.map((a) => a.id).join(",");
          this.$toast.success(
            "Aula(s) salva(s). Redirecionando para o lançamento de frequência..."
          );
          this.$router.push({
            name: "aulas.polivalencia.frequencia-lote",
            params: {
              gestaoDeAulaId: this.$route.params.gestaoDeAulaId,
              aula_ids: ids,
            },
          });
        } else if (criadas.length) {
          this.$toast.success("Aula(s) cadastrada(s) com sucesso!");
          this.$router.back();
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
    },
    async getAula() {
      const { aula_id } = this.$route.params;
      const response = await this.$services.gestoesDeAulasService.listarAulasGestao(
        this.$route.params.gestaoDeAulaId
      );

      this.turma = response.payload.gestaoDeAula.turma;
      this.gestaoDeAula = response.payload.gestaoDeAula;

      // Fonte de "quais componentes valem em cada dia+horário" (com extra_curricular) para a
      // criação por abas de horário (#7530) — mesmo endpoint já usado pela grade "Vínculo de
      // Dias e Horários" da gestão.
      if (this.gestaoDeAula?.id) {
        this.grade = await this.$services.gestoesDeAulasService.gradeHorarios(this.gestaoDeAula.id);
      }

      await this.buscarTodosHorarios();

      this.horarios = response.payload.horarios.filter((horario) => {
        if (this.gestaoDeAula.is_polivalencia) {
          return horario.descricao;
        }
        return horario.descricao;
      });

      const aulaSelecionada = await this.$services.aulasService.getAula(parseInt(aula_id, 10));
      this.horarioSelecionado = aulaSelecionada.horario ?? null;

      this.text = aulaSelecionada.conteudo;
      this.aulaSelecionada.data = aulaSelecionada.data;
      this.data = aulaSelecionada.data;
      const diaSemana = new Date(this.data).getDay();
      this.filtrarHorariosPorDiaDaSemana(diaSemana);

      if (this.gestaoDeAula.relacoesDiasHorarios) {
        this.diasPermitidosParaCriarAula = this.gestaoDeAula.relacoesDiasHorarios.map(
          (g) => g.dia.id
        );

        this.horarios = this.gestaoDeAula.relacoesDiasHorarios.map((g) => g.horario);

        this.horariosSabado = this.horarios;
        this.horariosSabado = this.horariosSabado.map((h) => {
          return {
            id: h.id,
            turno_id: h.turno_id,
            descricao: h.descricao ? h.descricao.split(" - ")[0] : "Horário",
            final: h.final,
            inicio: h.inicio,
          };
        });
        this.horariosDoComponente =
          new Date(this.data).getDay() === 5 ? this.horariosSabado : this.horarios;
      }
      return aulaSelecionada;
    },
    async loadData() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.buscarTodosHorarios();
        this.aulaSelecionada = await this.getAula();

        if (!this.aulaSelecionada.disciplinas) {
          this.aulaSelecionada.disciplinas = [];
        }

        if (this.turma.circuito_nota_id) {
          const response = await this.$services.etapasService.syncAllEtapasDisponiveis(
            this.turma.circuito_nota_id,
            this.$route.params.gestaoDeAulaId
          );
          this.etapas = response.etapas;
          this.idsEtapasDisponivels = response.disponiveis;

          this.etapas.forEach((element) => {
            this.verificarSeTemPedido(element.id);
          });

          if (this.editing) {
            this.getEtapa();
            this.horariosDefinidos = this.getHorariosDaAula(this.aulaSelecionada);
          }
        }
        if (this.aulaSelecionada.data) {
          this.aulaSelecionada.data = this.aulaSelecionada.data.split("-").reverse().join("/");
        }
        this.$forceUpdate();

        if (this.editing) {
          this.getConteudoPolivalencia();
          this.getHorariosPolivalencia();
          this.array_horarios_extras = JSON.parse(this.aulaSelecionada.horarios_extras) || [];
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    getEtapa() {
      let etapa = this.etapas.filter((d) => d.id === this.aulaSelecionada.etapa_id);
      etapa = etapa.shift();
      this.fimPeriodoEtapa = etapa.periodo_final;
      this.inicioPeriodoEtapa = etapa.periodo_inicial;
      this.etapaSelecionada = etapa;
    },
    criarPedido(etapaId) {
      this.$router.push({ name: "autorizacoes.create", params: { etapa: etapaId } });
    },
    verPedidos() {
      this.$router.push({ name: "autorizacoes" });
    },
    verificarSeEtapaEstaDisp(etapa) {
      if (this.idsEtapasDisponivels.includes(etapa.id)) {
        this.etapaBloqueada = false;
      } else {
        this.etapaBloqueada = true;
      }
      if (this.idsEtapasPendentes.includes(etapa.id)) {
        this.etapaPendente = true;
      } else {
        this.etapaPendente = false;
      }
    },
    async verificarSeTemPedido(etapaId) {
      const response = await this.$services.autorizacoesService.verificarPedidosDeferidos(etapaId);

      if (response.data.aprovados?.length) {
        this.idsEtapasDisponivels.push(etapaId);
      }

      if (response.data.pendentes?.length) {
        this.idsEtapasPendentes.push(etapaId);
      }
    },
    beforeDestroy() {
      this.text = this.$refs.editor.innerHTML;
    },
    getChipColor(dataExtensao) {
      if (!dataExtensao) return "primary";
      const hoje = new Date();
      const dataExt = new Date(dataExtensao);

      hoje.setHours(0, 0, 0, 0);
      dataExt.setHours(0, 0, 0, 0);

      if (dataExt >= hoje) {
        return "green";
      }
      return "red";
    },
    isFeriado(date) {
      return this.feriados.some((f) => f.data === date);
    },
    isDiaLetivo(date) {
      return this.diasLetivos.some((l) => l.data === date);
    },
    isDiaNaoLetivo(date) {
      return this.diasNaoLetivos && this.diasNaoLetivos.some((d) => d.data === date);
    },
    getBadgeColor(date) {
      const evento = (this.todosEventos || []).find((ev) => {
        const evData = ev.data.length > 10 ? ev.data.slice(0, 10) : ev.data;
        return evData === date;
      });
      if (evento) {
        return (
          evento.cor ||
          (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1 ? "green" : "red")
        );
      }

      if (this.isFeriado(date)) return "red";
      return "";
    },
    getBadgeContent(date) {
      const evento = (this.todosEventos || []).find((ev) => {
        const evData = ev.data.length > 10 ? ev.data.slice(0, 10) : ev.data;
        return evData === date;
      });
      if (evento) {
        if (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1) {
          return "Letivo";
        }
        return "Dia não letivo";
      }
      if (this.isFeriado(date)) return "F";
      return "";
    },
  },
};
</script>

<style scoped>
.dataInput {
  background-color: white;
  width: 100%;
  height: 35px;
  box-shadow: 2px 2px rgb(0, 0, 0, 0.1);
}

.events-card {
  margin-top: 20px;
}

.calendar-container-vertical {
  max-width: 100%;
  padding: 0;
}

.calendar-card-expanded {
  margin-bottom: 20px;
}

.expanded-date-picker {
  width: 100%;
}

.events-card-below {
  height: 100%;
  max-height: 300px;
  overflow-y: auto;
}

.event-list-expanded {
  max-height: 250px;
  overflow-y: auto;
}

.date-label {
  min-width: 30px;
  font-weight: bold;
}

.event-description {
  word-break: break-word;
}

.dialog-actions {
  padding: 16px;
  justify-content: flex-end;
}

/* Ajustes responsivos */
@media (max-width: 960px) {
  .calendar-container-vertical {
    flex-direction: column;
  }

  .calendar-card-expanded,
  .events-card-below {
    max-width: 100%;
  }

  .events-card-below {
    max-height: 250px;
  }
}
</style>
